import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHorizontalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconHorizontalAlignmentCenter"><Path d="M6 4V11.25H3V12.75H6V20.5H11V12.75H13V18H18V12.75H21V11.25H18V6H13V11.25H11V4H6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHorizontalAlignmentCenter;
